import { render, staticRenderFns } from "./PublicPageMenuExternalDialog.vue?vue&type=template&id=7554896b"
import script from "./PublicPageMenuExternalDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPageMenuExternalDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports